import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    emailType: String
  }
  static targets = ["content", "title", "error", "success", "sparkles", "aiLoading", "testEmail", "testLoading"]

  async composeWithAI(e) {
    e.target.disabled = true
    this.sparklesTarget.classList.add("hidden")
    this.aiLoadingTarget.classList.remove("hidden")
    
    const response = await fetch(`/dashboard/shared/email_customizations/${this.emailTypeValue}/compose_with_ai`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      }
    })
    if (response.ok) {
      const data = await response.json()
      this.contentTarget.innerHTML = data.content
    } else {
      this.showError("We ran into an error when trying to compose with AI. Please try again later.")
    }
    
    this.sparklesTarget.classList.remove("hidden")
    this.aiLoadingTarget.classList.add("hidden")
    window.setTimeout(() => {
      e.target.disabled = false
    }, 5000)
  }

  async sendTestEmail(e) {
    e.target.disabled = true
    this.testEmailTarget.classList.add("hidden")
    this.testLoadingTarget.classList.remove("hidden")

    const response = await fetch(`/dashboard/shared/email_customizations/${this.emailTypeValue}/send_test_email.turbo_stream`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      },
      body: JSON.stringify({
        title: this.titleTarget.value,
        content: this.contentTarget.innerHTML
      })
    });

    if (response.ok) {
      this.showSuccess("Test email sent successfully")
    } else {
      this.showError("We ran into an error when trying to send the test email. Please try again later.")
    }
    
    this.testEmailTarget.classList.remove("hidden")
    this.testLoadingTarget.classList.add("hidden")
    window.setTimeout(() => {
      e.target.disabled = false
    }, 5000)
  }

  showError(message) {
    this.errorTarget.innerHTML = message
    this.errorTarget.hidden = false
    this.successTarget.hidden = true
  }

  showSuccess(message) {
    this.successTarget.innerHTML = message
    this.successTarget.hidden = false
    this.errorTarget.hidden = true
    window.setTimeout(() => {
      this.successTarget.hidden = true
    }, 5000)
  }
}
